module.exports = __webpack_public_path__ + "img/18.0633a58d.png";